import { globalOptions } from 'Dictionaries/imports/importOptionsDictionary.js';

const opts = _.merge(
    {
        parameters: {
            description: window.i18n.__(
                'Cette section vous permet de déterminer le critère sur lequel nous allons déterminer si une service existe déjà dans vos données Sellsy',
            ),
        },
        identifiers: {
            service: {
                title: window.i18n.__('Critère de comparaison pour les services'),
                multiple: false,
                choices: [
                    {
                        value: 'reference',
                        label: window.i18n.__('Référence service'),
                        description: window.i18n.__('Référence ou code du service unique.'),
                    },
                    {
                        value: 'id',
                        label: window.i18n.__('Identifiant service'),
                        description: window.i18n.__('Récupéré uniquement depuis un export Sellsy'),
                    },
                ],
            },
        },
    },
    globalOptions,
);

delete opts.parameters.create;
delete opts.parameters.update.options.overwrite_tags;

export const options = opts;

export const defaultOptions = {
    identifiers: {
        service: ['reference'],
    },
};
